<style>
@import '../../assets/css/tool.css';
</style>

<template>
    <div class="main-panel" v-if="ajaxLoad === true">
        <div class="main-content">
            <div class="container-fluid">
                <b-card :header="$t($route.name)">
                    <b-button variant="primary" class="mb-3 float-right" v-if="permissionList.includes(permission.add)" @click="getAddVersionMsg()"><font-awesome-icon icon="plus"/> {{$t('versionmessage.table_add')}}</b-button>
                    <el-table class="custom-table" :data="ajaxTable" @expand-change="expandChange" @row-click="expandRow" ref="tableTest" border>
                        <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                            <template slot="header">
                                <p>{{title.label}}</p>
                                <b-form-input :placeholder="title.label" @keyup.enter="initialize()" v-model="ajaxSearch[title.prop]"></b-form-input>
                            </template>
                        </el-table-column>
                        <el-table-column type="expand">
                            <b-button variant="info" size="lg" @click="getEditVersionMsg()" v-if="permissionList.includes(permission.edit)">{{$t('versionmessage.table_edit')}}</b-button>
                            <b-button variant="danger" size="lg" class="ml-1" @click="deleteVersionMsg()" v-if="permissionList.includes(permission.delete)">{{$t('versionmessage.table_delete')}}</b-button>
                        </el-table-column>
                    </el-table>
                    <b-row class="mt-3">
                        <b-col sm="12" md="3" class="pr-0">
                            <span class="float-left">{{$t('admin.table_show_result',{result:ajaxTool.total_number})}}</span>
                        </b-col>
                        <b-col sm="12" md="9" class="pl-0">
                            <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChange" @current-change="paginationCurrentChange" :current-page.sync="ajaxTool.current_pagination" :total="ajaxTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                        </b-col>
                    </b-row>
                </b-card>
                
                <b-modal id="addVersionMsg" :title="$t('versionmessage.table_add')" @ok="addVersionMsg" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                    <form id="addVersionMsgForm" @submit.prevent="addVersionMsg">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_code')}}</template>
                            <b-form-input name="code"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_sort')}}</template>
                            <b-form-input name="sort" v-model="ajaxAdd.sort"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_status')}}</template>
                            <b-form-checkbox name="status" size="lg" value="1" unchecked-value="0" switch></b-form-checkbox>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="12" >
                            <template slot="label">{{$t('admin.table_name_title')}}</template>
                            <b-tabs class="center_pane" justified fill>
                                <b-tab v-for="(lang,key) in ajaxAdd.languageList" :key="key" :title="lang.name">
                                    <b-form-group label-cols="12" label-cols-lg="4">
                                        <template slot="label">{{$t('setting_package.table_name')}}</template>
                                        <b-form-input :name="'name[' + lang.code + ']'"></b-form-input>
                                    </b-form-group>
                                </b-tab>
                            </b-tabs>
                        </b-form-group>
                    </form>
                </b-modal>
                <b-modal id="editVersionMsg" :title="$t('versionmessage.table_edit')" @ok="editVersionMsg" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                    <form id="editVersionMsgForm" @submit.prevent="editVersionMsg">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_code')}}</template>
                            <b-form-input name="code" v-model="ajaxEdit.code"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_sort')}}</template>
                            <b-form-input name="sort" v-model="ajaxEdit.sort"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_status')}}</template>
                            <b-form-checkbox name="status" v-model="ajaxEdit.status" size="lg" value="1" unchecked-value="0" switch></b-form-checkbox>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="12" >
                            <template slot="label">{{$t('admin.table_name_title')}}</template>
                            <b-tabs class="center_pane" justified fill>
                                <b-tab v-for="(lang,key) in ajaxEdit.languageList" :key="key" :title="lang.name">
                                    <b-form-group label-cols="12" label-cols-lg="4">
                                        <template slot="label">{{$t('setting_package.table_name')}}</template>
                                        <b-form-input :name="'name[' + lang.code + ']'" v-model="ajaxEdit.name[lang.code]"></b-form-input>
                                    </b-form-group>
                                </b-tab>
                            </b-tabs>
                        </b-form-group>
                    </form>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import {versionMsgAjaxTable,versionMsgAdd,getVersionMsgEdit,versionMsgEdit,versionMsgDelete} from '@/system/model/tools'
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{   
            ajaxLoad:false,
            validate:true,
            ajaxTable:[],
            ajaxTool:[],
            ajaxSearch:{limit:'',pagination:'',id:'',code:'',name:'',sort:'',status:''},
            ajaxAdd:{sort:10,languageList:[]},
            ajaxEdit:[],
            ajaxRow:'',
            csrfName:'',
            csrfValue:'',
            csrfNameKey:'',
            csrfValueKey:'',
            pageLimit:10,
            errors: [],
            permission:{
                add:'49158F',
                edit:'946D69',
                delete:'D81B5A'
            },
            permissionList:[],
            titles:[{
                prop: "id",
                label: this.$t('admin.table_id'),
                width: '50'
            },{
                prop: "code",
                label: this.$t('admin.table_code'),
                width: '150'
            },{
                prop: "name",
                label: this.$t('admin.table_name'),
                width: '300'
            },{
                prop: "sort",
                label: this.$t('admin.table_sort'),
                width: '100'
            },{
                prop: "status",
                label: this.$t('admin.table_status'),
                width: '100'
            }], 
        }
    },methods:{
        initialize(){
            var self = this;
            var result = versionMsgAjaxTable(this.ajaxSearch.limit,this.ajaxSearch.pagination,this.ajaxSearch.id,this.ajaxSearch.code,this.ajaxSearch.name,this.ajaxSearch.sort,this.ajaxSearch.status);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                    self.permissionList = JSON.parse(getLocalStorage('permission_list'));
                }else{
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },getAddVersionMsg(){
            var self = this;
            var result = this.$general.getLanguageList();
            result.then(function(value){
                self.$bvModal.show('addVersionMsg');
                self.ajaxAdd.languageList = value.data;
            });
        },addVersionMsg(){
            if(this.permissionList.includes(this.permission.add)){
                var self = this;
                this.preloader(true);
                var form = document.getElementById('addVersionMsgForm');
                var formData = new FormData(form);
                formData.append(this.csrfNameKey, this.csrfName); 
                formData.append(this.csrfValueKey, this.csrfValue); 
                var result = versionMsgAdd(formData);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$swal.fire({
                            type: 'success',
                            text: self.$t(value.returnMsg),
                            onClose: () => {
                                self.initialize();            
                            }
                        });
                    }else{
                        var text = "";
                        if(Array.isArray(value.returnMsg)){
                            value.returnMsg.forEach(function (value) {
                                text += self.$t(value)+"<br />";
                            }); 
                        }else{
                            text = self.$t(value.returnMsg);
                        }

                        self.$swal.fire({
                            type: 'error',
                            html: text,
                            onClose: () => {
                                self.initialize();            
                            }
                        });
                    }
                });      
            }      
        },getEditVersionMsg(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                var result = getVersionMsgEdit(this.ajaxRow);
                this.preloader(true);
                result.then(function(value){
                    if(value.valid){
                        self.preloader(false)
                        self.$bvModal.show('editVersionMsg');
                        self.ajaxEdit = value.data;
                        self.ajaxEdit.languageList = value.language;
                    }else{
                        self.preloader(true)
                        var text = "";
                        this.errors.forEach(function (value) {
                            text += self.$t(value)+"<br />";
                        }); 
                        
                        this.$swal.fire({
                            type: 'error',
                            html: text
                        });
                    }
                })
            }
        },editVersionMsg(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                this.preloader(true);
                var form = document.getElementById('editVersionMsgForm');
                var formData = new FormData(form);
                formData.append(this.csrfNameKey, this.csrfName); 
                formData.append(this.csrfValueKey, this.csrfValue); 
                formData.append('id', this.ajaxEdit.id);
                var result = versionMsgEdit(formData);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$swal.fire({
                            type: 'success',
                            text: self.$t(value.returnMsg),
                            onClose: () => {
                                self.initialize();            
                            }
                        });
                    }else{
                        var text = "";
                        if(Array.isArray(value.returnMsg)){
                            value.returnMsg.forEach(function (value) {
                                text += self.$t(value)+"<br />";
                            }); 
                        }else{
                            text = self.$t(value.returnMsg);
                        }

                        self.$swal.fire({
                            type: 'error',
                            html: text,
                            onClose: () => {
                                self.initialize();            
                            }
                        });
                    }
                })
            }
        },deleteVersionMsg(){
            if(this.permissionList.includes(this.permission.delete)){
                this.$swal.fire({
                text: this.$t('msg.confirm_delete'),
                type: 'info',
                showCancelButton: true,
                confirmButtonText: this.$t('button.confirm'),
                cancelButtonText: this.$t('button.cancel'),
                }).then((result)=>{
                    if(result.value){
                        var self = this;
                        self.preloader(true);
                        var formData = new FormData();
                        formData.append(this.csrfNameKey, this.csrfName); 
                        formData.append(this.csrfValueKey, this.csrfValue); 
                        formData.append('id', this.ajaxRow); 
                        var result = versionMsgDelete(formData);		
                        result.then(function(value){
                            self.preloader(false);
                            if(value.valid){
                                self.$swal.fire({
                                    type: 'success',
                                    text: self.$t(value.returnMsg),
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }else{
                                var text = "";
                                if(Array.isArray(value.returnMsg)){
                                    value.returnMsg.forEach(function (value) {
                                        text += self.$t(value)+"<br />";
                                    }); 
                                }else{
                                    text = self.$t(value.returnMsg);
                                }

                                self.$swal.fire({
                                    type: 'error',
                                    html: text,
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }
                        });
                    }
                });
            }
        },expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
            this.ajaxRow = row.id
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },paginationSizeChange(limit){
            this.ajaxSearch.limit = limit;
            this.initialize();
        },paginationCurrentChange(pagination){
            this.ajaxSearch.pagination = pagination;
            this.initialize();
        }
    },created(){
        this.preloader(false);
        this.initialize();
    }
}
</script>
